import { useState, useEffect } from 'react'
import { VITE_API_BASE } from '../config/apiConfig'

export default function PartnerUnifiedLogin() {
  const [phone, setPhone] = useState('')
  const [code, setCode] = useState('')
  const [promoType, setPromoType] = useState('personal') // personal / certified / agency
  const [step, setStep] = useState('login') // login / register / dashboard
  const [error, setError] = useState('')
  const [countdown, setCountdown] = useState(0)
  const [userInfo, setUserInfo] = useState(null)
  const [referrerId, setReferrerId] = useState('')
  const [referrerName, setReferrerName] = useState('')

  // 从URL读取推荐人ID
  useEffect(() => {
    const params = new URLSearchParams(window.location.search)
    const ref = params.get('ref') || ''
    if (ref) {
      setReferrerId(ref)
      // 尝试获取推荐人信息
      fetch(`${VITE_API_BASE}/partners/${ref}`)
        .then(r => r.json())
        .then(d => { if (d.success) setReferrerName(d.data.name) })
        .catch(e => { console.error(e) })
    }
  }, [])

  const promoTypes = {
    personal: { name: '个人推广员', color: '#13c2c2', fee: '免费', commission: '30%-60%', features: ['免费注册', 'AI动画类佣金30%', '线上课程佣金60%', '无系统权限', '不能招募下线'] },
    certified: { name: '认证推广员', color: '#722ed1', fee: '¥5,000/年', commission: '40%-80%', features: ['AI动画类佣金40%', '线上课程佣金80%', '完整系统权限', '可招募下线', '招募奖¥100/人', '管理奖20%'] },
    agency: { name: '机构推广合伙人', color: '#fa8c16', fee: '¥5,000/年+SaaS', commission: '50%-80%', features: ['AI动画类佣金50%', '线上课程佣金80%', '完整系统权限', '线下活动利润100%', '可招募下线', '前提：必须购买SaaS'] }
  }

  const sendCode = async () => {
    if (!phone || phone.length !== 11) {
      setError('请输入正确的11位手机号')
      return
    }
    setError('')
    try {
      const res = await fetch(`${VITE_API_BASE}/sms/send`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ phone, type: 'partner_login' })
      })
      const data = await res.json()
      if (data.success || data.code === 200) {
        setCountdown(60)
        const t = setInterval(() => {
          setCountdown(c => {
            if (c <= 1) { clearInterval(t); return 0 }
            return c - 1
          })
        }, 1000)
      } else {
        setError(data.error || '发送失败')
      }
    } catch {
      setError('网络错误')
    }
  }

  const handleLogin = async () => {
    setError('')
    if (!phone || !code) {
      setError('请输入手机号和验证码')
      return
    }
    setStep('loading')
    try {
      const res = await fetch(`${VITE_API_BASE}/partner-login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ phone, code, promo_type: promoType })
      })
      const data = await res.json()
      if (data.success) {
        localStorage.setItem('cms_token', data.token)
        localStorage.setItem('cms_user', JSON.stringify(data.user))
        localStorage.setItem('promo_type', promoType)
        setUserInfo(data.user)
        setStep('dashboard')
      } else {
        setError(data.error || '登录失败')
        setStep('login')
      }
    } catch {
      setError('网络错误，请稍后重试')
      setStep('login')
    }
  }

  const handleRegister = () => {
    setStep('register')
  }

  const currentPromo = promoTypes[promoType]

  // 推广员面板
  if (step === 'dashboard') {
    return (
      <div style={{ minHeight: '100vh', background: '#f0f2f5', padding: '40px 20px' }}>
        <div style={{ maxWidth: 800, margin: '0 auto' }}>
          {/* 头部 */}
          <div style={{ background: `linear-gradient(135deg, ${currentPromo.color} 0%, ${currentPromo.color}99 100%)`, borderRadius: 16, padding: 24, color: '#fff', marginBottom: 24 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <div>
                <div style={{ fontSize: 24, fontWeight: 600 }}>{userInfo?.name || '推广员'}</div>
                <div style={{ opacity: 0.9, marginTop: 4 }}>{currentPromo.name}</div>
              </div>
              <div style={{ textAlign: 'right' }}>
                <div style={{ fontSize: 13, opacity: 0.8 }}>佣金比例</div>
                <div style={{ fontSize: 28, fontWeight: 700 }}>{currentPromo.commission}</div>
              </div>
            </div>
          </div>

          {/* 统计卡片 */}
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 16, marginBottom: 24 }}>
            {[
              { label: '可提现余额', value: '¥' + (userInfo?.balance || 0), icon: '💰', color: '#fa8c16' },
              { label: '累计收益', value: '¥' + (userInfo?.totalEarnings || 0), icon: '📈', color: '#52c41a' },
              { label: '推广订单', value: userInfo?.orderCount || 0, icon: '📋', color: '#1890ff' },
            ].map(s => (
              <div key={s.label} style={{ background: '#fff', borderRadius: 12, padding: 20, textAlign: 'center' }}>
                <div style={{ fontSize: 28 }}>{s.icon}</div>
                <div style={{ fontSize: 24, fontWeight: 600, color: s.color, marginTop: 8 }}>{s.value}</div>
                <div style={{ fontSize: 13, color: '#999', marginTop: 4 }}>{s.label}</div>
              </div>
            ))}
          </div>

          {/* 推广链接 */}
          <div style={{ background: '#fff', borderRadius: 12, padding: 20, marginBottom: 24 }}>
            <h4 style={{ fontSize: 14, marginBottom: 12 }}>🔗 我的推广链接</h4>
            <div style={{ display: 'flex', gap: 8 }}>
              <input 
                type="text" 
                readOnly 
                value={`${window.location.origin}/?ref=${userInfo?.id || ''}`}
                style={{ flex: 1, padding: '10px 12px', border: '1px solid #d9d9d9', borderRadius: 6, fontSize: 13 }}
              />
              <button style={{ padding: '10px 16px', background: '#1890ff', color: '#fff', border: 'none', borderRadius: 6, cursor: 'pointer' }}>复制</button>
            </div>
            <div style={{ fontSize: 12, color: '#999', marginTop: 8 }}>分享链接给好友，好友下单后您可获得佣金</div>
          </div>

          {/* 佣金说明 */}
          <div style={{ background: '#fff', borderRadius: 12, padding: 20 }}>
            <h4 style={{ fontSize: 14, marginBottom: 12, color: currentPromo.color }}>💡 我的权益</h4>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 12 }}>
              {currentPromo.features.map((f, i) => (
                <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 13 }}>
                  <span style={{ color: '#52c41a' }}>✓</span>
                  <span>{f}</span>
                </div>
              ))}
            </div>
          </div>

          <button 
            onClick={() => { localStorage.clear(); setStep('login'); setUserInfo(null); }}
            style={{ width: '100%', marginTop: 24, padding: 12, background: '#fff', border: '1px solid #d9d9d9', borderRadius: 6, cursor: 'pointer', fontSize: 14 }}
          >
            退出登录
          </button>
        </div>
      </div>
    )
  }

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' }}>
      <div style={{ background: '#fff', borderRadius: 16, padding: 40, width: 420, boxShadow: '0 20px 60px rgba(0,0,0,0.2)' }}>
        {/* Logo */}
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <div style={{ fontSize: 36, marginBottom: 8 }}>🎋</div>
          <h2 style={{ fontSize: 24, margin: '0 0 4px', color: '#333' }}>博小兔推广员系统</h2>
          <p style={{ color: '#999', margin: 0, fontSize: 13 }}>开启您的轻创业之旅</p>
        </div>

        {error && (
          <div style={{ background: '#fff2f0', border: '1px solid #ffccc7', color: '#f5222d', padding: '10px 12px', borderRadius: 8, marginBottom: 16, fontSize: 13 }}>
            {error}
          </div>
        )}

        {/* 推荐人提示 */}
        {referrerName && (
          <div style={{ background: '#f6ffed', border: '1px solid #b7eb8f', borderRadius: 8, padding: 12, marginBottom: 16 }}>
            <div style={{ fontSize: 13, color: '#52c41a' }}>
              ✓ 推荐人：{referrerName}
            </div>
          </div>
        )}

        {/* 推广员类型选择 */}
        <div style={{ marginBottom: 24 }}>
          <label style={{ display: 'block', marginBottom: 12, fontSize: 14, color: '#666' }}>选择推广身份</label>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 8 }}>
            {Object.entries(promoTypes).map(([key, info]) => (
              <div
                key={key}
                onClick={() => setPromoType(key)}
                style={{
                  padding: '12px 8px',
                  border: '2px solid',
                  borderColor: promoType === key ? info.color : '#e8e8e8',
                  background: promoType === key ? `${info.color}11` : '#fff',
                  borderRadius: 8,
                  cursor: 'pointer',
                  textAlign: 'center',
                  transition: 'all 0.2s'
                }}
              >
                <div style={{ fontSize: 12, fontWeight: 600, color: promoType === key ? info.color : '#666' }}>{info.name}</div>
                <div style={{ fontSize: 11, color: '#999', marginTop: 4 }}>{info.fee}</div>
              </div>
            ))}
          </div>
        </div>

        {/* 当前权益 */}
        <div style={{ background: `${currentPromo.color}11`, borderRadius: 8, padding: 12, marginBottom: 20 }}>
          <div style={{ fontSize: 12, color: currentPromo.color, fontWeight: 600, marginBottom: 8 }}>
            {currentPromo.name} 权益
          </div>
          <div style={{ fontSize: 12, color: '#666', lineHeight: 1.6 }}>
            {currentPromo.features.map((f, i) => (
              <span key={i}>• {f} &nbsp;</span>
            ))}
          </div>
        </div>

        {/* 手机号 */}
        <div style={{ marginBottom: 16 }}>
          <label style={{ display: 'block', marginBottom: 8, fontSize: 13, color: '#666' }}>手机号</label>
          <input
            type="tel"
            placeholder="请输入手机号"
            value={phone}
            onChange={e => setPhone(e.target.value)}
            maxLength={11}
            style={{ width: '100%', padding: '12px', border: '1px solid #d9d9d9', borderRadius: 8, fontSize: 14, boxSizing: 'border-box' }}
          />
        </div>

        {/* 验证码 */}
        <div style={{ marginBottom: 24 }}>
          <label style={{ display: 'block', marginBottom: 8, fontSize: 13, color: '#666' }}>验证码</label>
          <div style={{ display: 'flex', gap: 8 }}>
            <input
              type="text"
              placeholder="请输入验证码"
              value={code}
              onChange={e => setCode(e.target.value)}
              maxLength={6}
              style={{ flex: 1, padding: '12px', border: '1px solid #d9d9d9', borderRadius: 8, fontSize: 14 }}
            />
            <button
              onClick={sendCode}
              disabled={countdown > 0}
              style={{ 
                padding: '12px 16px', 
                background: countdown > 0 ? '#f5f5f5' : currentPromo.color, 
                color: countdown > 0 ? '#999' : '#fff', 
                border: 'none', 
                borderRadius: 8, 
                fontSize: 13, 
                cursor: countdown > 0 ? 'not-allowed' : 'pointer',
                whiteSpace: 'nowrap'
              }}
            >
              {countdown > 0 ? `${countdown}s` : '获取验证码'}
            </button>
          </div>
          <div style={{ marginTop: 8, fontSize: 12, color: '#1890ff' }}>演示验证码：123456</div>
        </div>

        {/* 登录按钮 */}
        <button
          onClick={handleLogin}
          disabled={step === 'loading'}
          style={{ 
            width: '100%', 
            padding: '14px', 
            background: currentPromo.color, 
            color: '#fff', 
            border: 'none', 
            borderRadius: 8, 
            fontSize: 16, 
            cursor: step === 'loading' ? 'not-allowed' : 'pointer',
            opacity: step === 'loading' ? 0.7 : 1,
            fontWeight: 600
          }}
        >
          {step === 'loading' ? '登录中...' : '登录 / 注册'}
        </button>

        {/* 注册提示 */}
        {promoType !== 'personal' && (
          <div style={{ marginTop: 16, textAlign: 'center', fontSize: 12, color: '#999' }}>
            注册后需完成 {currentPromo.fee} 认证才能享受对应权益
          </div>
        )}

        {/* 分隔线 */}
        <div style={{ margin: '24px 0', borderTop: '1px solid #f0f0f0' }} />

        {/* 没有账号？前往申请 */}
        <div style={{ textAlign: 'center' }}>
          <div style={{ fontSize: 13, color: '#999', marginBottom: 12 }}>还没有账号？选择身份申请加入</div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
            {[
              { label: '机构申请', page: 'institution-register', color: '#1890ff' },
              { label: '基地申请', page: 'base-register', color: '#52c41a' },
              { label: '区域代理申请', page: 'regional-agent-register', color: '#fa8c16' },
              { label: '推广员申请', page: 'partner-apply', color: '#722ed1' },
            ].map(item => (
              <button
                key={item.page}
                onClick={() => window.location.href = '/cms/?page=' + item.page}
                style={{
                  padding: '10px 8px',
                  background: `${item.color}11`,
                  border: `1px solid ${item.color}44`,
                  color: item.color,
                  borderRadius: 8,
                  cursor: 'pointer',
                  fontSize: 12,
                  fontWeight: 500,
                  transition: 'all 0.2s'
                }}
              >
                {item.label} →
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}
